import { AbstractDialogContent } from '@abstracts/dialog/dialog-content';
import { Component, Injector, OnInit } from '@angular/core';
import { IEntity } from '@interfaces/entity';
import { ChargingStation } from '@models/charging-station';
import { ChargingPoint } from '@models/chargingPoint';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ChargingStationsService } from '@services/entity/charging-stations.service';
import { FormService } from '@services/form/form.service';
import { ToastService } from '@services/toast/toast.service';
import Swal from 'sweetalert2';
import { Address } from '../../../../models/address';

@Component({
  selector: 'app-mass-create-charging-station-dialog-content',
  templateUrl: './mass-create-charging-station-dialog-content.component.html',
  styleUrls: ['./mass-create-charging-station-dialog-content.component.scss']
})
export class MassCreateChargingStationDialogContentComponent extends AbstractDialogContent implements OnInit {

  public className = 'MassCreateChargingStationDialogContentComponent';

  public customerId: number;
  public numOfChargingStations: number;
  public passwordLength: number = 12;
  public includeNumbers: boolean = true;
  public includeSymbols: boolean = false;
  public password: string = '';

  constructor(
    public activeModal: NgbActiveModal,
    public chargingStationsService: ChargingStationsService,
    public formService: FormService,
    public toastService: ToastService,
    injector: Injector
  ) {
    super(activeModal, injector);
  }

  ngOnInit(): void {
    super.ngOnInit();
  }


  pwlength(event) {
    this.passwordLength = event.target.value;
    console.log(this.passwordLength);
  }

  hasNum(event) {
    this.includeNumbers = event.target.checked;
    console.log(this.includeNumbers);
  }

  hasSym(event) {
    this.includeSymbols = event.target.checked;
    console.log(this.includeSymbols);
  }

  generatePassword() {
    const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    const numbers = '0123456789';
    const symbols = '!@#$%^&*()_+-=[]{}|;:,.<>?';

    let validChars = letters;
    if (this.includeNumbers) {
      validChars += numbers;
    }
    if (this.includeSymbols) {
      validChars += symbols;
    }

    let generatedPassword = '';
    for (let i = 0; i < this.passwordLength; i++) {
      const index = Math.floor(Math.random() * validChars.length);
      generatedPassword += validChars[index];
    }

    this.password = generatedPassword;
    this.formService.form.controls['key'].setValue(this.password);

  }


  onSubmit(formValue) {
    //console.log(formValue);
    this.numOfChargingStations = formValue.numOfChargingStations;
    var address = new Address();
    address.city = formValue.city;
    address.postalCode = formValue.postalCode;
    address.houseNumber = formValue.houseNumber;
    address.street = formValue.street;
    formValue.Address = address;
    formValue.location = formValue.street + " " + formValue.houseNumber + ", " + formValue.postalCode + " " + formValue.city;
    var entity = new ChargingStation(formValue);
    //console.log(entity);
    var name = entity.name;
    if (this.customerId) {
      for (let index = 0; index <= this.numOfChargingStations; index++) {
        this.generatePassword();
        entity.key = this.password;
        entity.name = name +' - '+index;
        this.chargingStationsService.createChargingstationForCustomer(this.customerId, entity).subscribe(
          data => {
            this.activeModal.close();
          },
          err => { },
          () => {
            this.toastService.success($localize`:@@CreateDialogSaveSuccessHeader:Ladestation erfolgreich gespeichert.`);
          }
        );
      }

    } else {
      this.chargingStationsService.createEntity(entity).subscribe(data => {
        this.activeModal.close();
        this.toastService.success($localize`:@@CreateDialogSaveSuccessHeader:Ladestation erfolgreich gespeichert.`);
      }, error => {});
    }
  }

  newEntityEvent(entity: IEntity) {
    this.activeModal.close();
  }
}
